import { render, staticRenderFns } from "./QuestionIndex.vue?vue&type=template&id=6705c3ba&"
import script from "./QuestionIndex.vue?vue&type=script&lang=js&"
export * from "./QuestionIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports